module.exports = __webpack_public_path__ + "static/media/compass-background.aa7f20db.svg";